export enum EntitlementName {
  RBAC = 'RBAC',
  AnalyticsFilters = 'AnalyticsFilters',
  AnalyticsComponents = 'AnalyticsComponents',
  ABTesting = 'ABTesting',
  Goals = 'Goals',
  Embeds = 'Embeds',
  Inline = 'Inline',

  Checklist = 'Checklist',
  Collections = 'Collections',
  Forms = 'Forms',

  Segments = 'Segments',
  Workspaces = 'Workspaces',
}
